<template>

  <span>
    <svg
        v-if="waitingApprove && isMentor"
        style="width: 20px;margin-top:2px;float: left;margin-right: 10px;color: red;animation: tada 1.5s ease infinite;margin-left: -10px;"
        xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20"
        fill="currentColor">
      <path fill-rule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"/>
    </svg>

    <svg
        v-if="finishedApprove"
        style="width: 20px;margin-top:2px;float: left;margin-right: 10px;color: green;animation: tada 1.5s ease infinite;margin-left: -10px;"
        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd"
            d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd"/>
    </svg>
  </span>
</template>

<script>

export default {
  name: 'SectionStatus',
  props: {
    step: {
      type: Object,
      default: function () {
        return {}
      }
    },
    project: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    waitingApprove: function () {

      let steps = this.step.subSteps.filter((item) => {
        return item.is_active == 2
      })

      return steps.length
    },
    finishedApprove: function () {

      let all = this.step.subSteps.length

      let steps = this.step.subSteps.filter((item) => {
        return item.is_active == 3
      })

      return all == steps.length
    },
    isMentor: function () {

      let user = this.$store.getters['shared/getUser']

      if (!user) {
        return null
      }

      if (!this.project) {
        return null
      }

      let currentUserRoles = this.project.share.find((item) => {
        return item.user_id == user.id
      })

      return currentUserRoles.is_mentor
    }
  }

};
</script>
